import { Action } from "../../store/types";
import { ProductStyle } from "../../models";
import * as actions from "./actions";

export type StyleSelectionsState = {
  [id: number]: ProductStyle;
};

export interface StyleChoiceState {
  styles: ProductStyle[];
  selectedStyle?: ProductStyle;
  isStylesLoading: boolean;
  descriptionValue: string;
  lastStyleChanged: number; // Internal reducer use
}

const initState: StyleChoiceState = {
  styles: [],
  selectedStyle: undefined,
  isStylesLoading: false,
  descriptionValue: "",
  lastStyleChanged: 0,
};

export default function(
  state = initState,
  { type, payload }: Action,
): StyleChoiceState {
  switch (type) {
    case actions.SET_DESC_VAL:
      return { ...state, descriptionValue: payload };
    case actions.SET_STYLES:
      return { ...state, styles: payload };
    case actions.SET_STYLES_LOADING:
      return { ...state, isStylesLoading: payload };
    case actions.SET_STYLE_SELECTION:
      return { ...state, selectedStyle: payload };
    case actions.RESET:
      return initState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/routes/WizardStyleChoice/reducer.ts